import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { format, isSameDay } from "date-fns";
import { setFilterNps } from "../../../actions/npsFilters";
import "./filters-tags.css";

export default function FiltersTags({ screen }) {
  const dispatch = useDispatch();
  const filters = useSelector((state) => state.npsfilters);

  const finalDateDefault = new Date();
  const initialDateDefault =
    screen === "Comparisons"
      ? new Date(new Date().setFullYear(new Date().getFullYear() - 1))
      : new Date(new Date().setDate(new Date().getDate() - 30));

  // Define dinamicamente quais chaves de data usar baseado na tela atual
  const isComparisonsScreen = screen === "Comparisons";
  const startKey = isComparisonsScreen ? "datestartComparisons" : "datestart";
  const endKey = isComparisonsScreen ? "dateendComparisons" : "dateend";

  const currentStartDate = filters[startKey]
    ? new Date(filters[startKey])
    : initialDateDefault;
  const currentEndDate = filters[endKey]
    ? new Date(filters[endKey])
    : finalDateDefault;

  const isDateDefault =
    isSameDay(currentStartDate, initialDateDefault) &&
    isSameDay(currentEndDate, finalDateDefault);

  const handleRemoveArrayFilter = (filterKey, idToRemove) => {
    const currentArray = filters[filterKey] || [];
    const updatedArray = currentArray.filter((item) => item.id !== idToRemove);
    dispatch(setFilterNps(filterKey, updatedArray));
    window.localStorage.setItem("npsFiltersChange", true);
  };

  const handleResetDate = () => {
    // Reseta as chaves corretas baseadas na tela atual
    dispatch(setFilterNps(startKey, initialDateDefault));
    dispatch(setFilterNps(endKey, finalDateDefault));
    dispatch(setFilterNps("period", [{ id: 5, label: "Personalizar" }]));
  };

  const activeTags = [];

  activeTags.push({
    key: "date",
    label: `${format(currentStartDate, "dd/MM/yyyy")} - ${format(currentEndDate, "dd/MM/yyyy")}`,
    removable: !isDateDefault,
    onRemove: handleResetDate,
  });

  // Removemos o 'comparison' da inicialização padrão
  const arrayFilters = [
    { key: "business", data: filters.business },
    { key: "units", data: filters.units },
    { key: "questionsNPS", data: filters.questionsNPS },
    { key: "questionsCSAT", data: filters.questionsCSAT },
    { key: "channels", data: filters.channels },
  ];

  // Adicionamos o 'comparison' apenas nas telas permitidas
  if (screen === "Comparisons" || screen === "Dealing") {
    arrayFilters.push({ key: "comparison", data: filters.comparison });
  }

  arrayFilters.forEach(({ key, data }) => {
    if (data && data.length > 0) {
      data.forEach((item) => {
        if (
          key === "comparison" &&
          item.id === "PROMOTOR" &&
          data.length === 1 &&
          !filters.active
        ) {
          return;
        }

        activeTags.push({
          key: `${key}-${item.id}`,
          label: item.label || item.name,
          removable: true,
          onRemove: () => handleRemoveArrayFilter(key, item.id),
        });
      });
    }
  });

  if (activeTags.length === 0) return null;

  return (
    <div className="filters-tags-wrapper">
      <div className="filters-tags-container">
        {activeTags.map((tag) => (
          <div className="filter-tag-item" key={tag.key}>
            <span className="filter-tag-label">{tag.label}</span>
            {tag.removable && (
              <button
                type="button"
                className="filter-tag-close-btn"
                onClick={tag.onRemove}
                aria-label={`Remover filtro ${tag.label}`}
              >
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle cx="12" cy="12" r="10"></circle>
                  <line x1="15" y1="9" x2="9" y2="15"></line>
                  <line x1="9" y1="9" x2="15" y2="15"></line>
                </svg>
              </button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
